import { memo, useMemo } from 'react'
import { useAppSelector } from '@/hooks/store'
import { useMapSpotName } from '@/hooks/useMapSpotName'
import { mapElementSelector } from '@/store/mapSlice'
import { getFormattedReservationKey } from '@/utils/getFormattedReservationKey'
import { priceFormatter } from '@/utils/price'
import { SkeletonText } from '../SkeletonText'

interface Props {
  reservationKey: string
  value: number
  isQuotePending: boolean
}

export const QuoteReservation = memo(function QuoteReservation({
  reservationKey,
  value,
  isQuotePending,
}: Props) {
  const { spotType, name } = getFormattedReservationKey(reservationKey)
  const mapElement = useAppSelector((state) =>
    mapElementSelector(state, {
      spotName: name,
      spotType,
    })
  )
  const { getMapSpotName } = useMapSpotName()
  const title = useMemo(
    () => (mapElement ? getMapSpotName(mapElement) : ''),
    [mapElement]
  )

  return (
    <div
      className="flex items-end justify-between gap-1 text-sm text-secondary"
      key={reservationKey}
    >
      <span className="break-word">{title}</span>
      <SkeletonText
        className="w-12"
        isPending={isQuotePending}
        text={priceFormatter.format(value)}
      />
    </div>
  )
})
